module.exports = __webpack_public_path__ + "f62f94b724062b47142a67d3bee68fc8.png";